import React from 'react';
import { ActivityIndicator } from 'react-native';
import { Theme, ThemedView } from '@app/theme';
import { useTheme } from '@shopify/restyle';
import { isFromTDLPlatform } from '@app/utils';
import LottieView from 'lottie-react-native'

const PageLoader: React.FC<any> = () => {

    const { colors } = useTheme<Theme>();
    const isFromTDL = isFromTDLPlatform();
    return (
        <ThemedView backgroundColor="bg-surface-primary" justifyContent={"center"} alignItems={"center"} flex={1}>
            {isFromTDL ? <LottieView source={require('../../../assets/lottie/tdl_loader.json')} style={{width: 273, height: 378}} autoPlay={true} loop={true} /> : <ActivityIndicator size={12} color={colors['icon-action-primary']} />}
        </ThemedView>
    );
};

export default PageLoader;
